import React from 'react';
import AppHeader from 'src/components/Header/AppHeader';
import AppRouter from './AppRouter';
import PrivateRoute from './PrivateRoute';
import { useSelector } from 'react-redux';
import { getConfigMsg } from 'src/slices/onBoardingSlice';

const ForgeWrpper = () => {
    useSelector(getConfigMsg);
    return (
        <>
           <AppHeader menu={false}/>
           <AppRouter Wrapper={PrivateRoute}/>
        </>
     
    );
};

export default ForgeWrpper;


